import { useEffect, useState } from 'react';
import { getSweepOptIn, saveSweepOptIn, SweepOptIn } from '../../api/issues';
import { describeError } from '../../api/requeue';
import { useAxiosSwagger } from '../../hooks/useAxiosSwagger';
import { moment } from './issueFormat';

export interface ISweepOptInToggleProps {
    customer: string;
    environment: string;
}

/**
 * Takes this environment along in every round of the scanner's timer, on top of the scope set
 * on the Issues page. Admin only, like the endpoint behind it.
 */
export const SweepOptInToggle = ({ customer, environment }: ISweepOptInToggleProps) => {
    const axios = useAxiosSwagger();
    const [optIn, setOptIn] = useState<SweepOptIn | null>(null);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (!axios) {
            return;
        }

        let current = true;

        getSweepOptIn(axios, customer, environment)
            .then((read) => current && setOptIn(read))
            .catch((ex) => current && setError(describeError(ex)));

        return () => {
            current = false;
        };
    }, [axios, customer, environment]);

    const change = (included: boolean) => {
        if (!axios) {
            return;
        }

        setBusy(true);
        setError(null);

        saveSweepOptIn(axios, customer, environment, included)
            .then(setOptIn)
            .catch((ex) => setError(describeError(ex)))
            .finally(() => setBusy(false));
    };

    const title = error
        ? error
        : optIn?.changedBy
        ? `${optIn.included ? 'Aangezet' : 'Uitgezet'} door ${optIn.changedBy} op ${moment(optIn.changedAt)}`
        : undefined;

    return (
        <label className="env-card__opt-in form-check" title={title}>
            <input
                type="checkbox"
                className="form-check-input"
                checked={optIn?.included === true}
                disabled={busy || !optIn}
                onChange={(event) => change(event.target.checked)}
            />
            <span className="form-check-label">Meenemen</span>
            {error && <span className="text-danger"> (mislukt)</span>}
        </label>
    );
};
